import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  sendRequest as resendConfirmToken,
  selectRequestState
} from 'mt-react-common/modules/users/common/reducers/forms/resendConfirmTokenAction';
import OpacityPreLoader from '../../../../Common/PreLoaders/OpacityPreLoader';

import CancelEmailChangeRequestLink from '../_common/CancelEmailChangeRequestLink';

const resendEmailConfirmTokenActionRN =
  'usersModule.forms.resendEmailConfirmTokenAction';

class EmailConfirmNoticeBlock extends Component {
  state = {
    hasLoading: false
  };

  handleResendConfirmToken = e => {
    e.preventDefault();
    this.props.resendConfirmToken();
  };

  render() {
    return (
      <div>
        <article className="panel panel-success">
          <div className="panel-heading text-center">
            <h3 className="panel-title">Подтверждение почты</h3>
          </div>
          <div className="panel-body">
            {this.props.requestState.hasInProgress || this.state.hasLoading ? (
              <OpacityPreLoader />
            ) : null}
            <p>
              На ваш адрес{' '}
              <strong>{this.props.authAccountData.newEmail}</strong> отправлено
              письмо со ссылкой для подтверждения почты.
            </p>
            <p>
              Если письма нет, проверьте папочку спам или сделайте{' '}
              <a href="" onClick={this.handleResendConfirmToken}>
                повторный запрос
              </a>
              .
            </p>
            <p className="m-b-0">
              <CancelEmailChangeRequestLink
                authAccountData={this.props.authAccountData}
                setLoading={bool => {
                  this.setState({
                    hasLoading: bool
                  });
                }}
              />
            </p>
          </div>
        </article>
      </div>
    );
  }
}

EmailConfirmNoticeBlock.propTypes = {
  // IN
  authAccountData: PropTypes.shape({
    email: PropTypes.string.isRequired,
    newEmail: PropTypes.string.isRequired,
    emailConfirm: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  resendConfirmToken: PropTypes.func.isRequired,
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired
  }).isRequired
};

const mapStateToProps = state => ({
  requestState: selectRequestState(state, resendEmailConfirmTokenActionRN)
});

const mapDispatchToProps = dispatch => ({
  resendConfirmToken: () =>
    dispatch(resendConfirmToken(resendEmailConfirmTokenActionRN))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EmailConfirmNoticeBlock);



// WEBPACK FOOTER //
// ./src/components/UserAccount/Confirms/ConfirmNoticeBlocks/EmailConfirmNoticeBlock/EmailConfirmNoticeBlock.js